import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import productimage15 from '../../images/product-img-15.jpg'
import productimage16 from '../../images/product-img-16.jpg'
import productimage17 from '../../images/product-img-17.jpg'
import productimage18 from '../../images/product-img-18.jpg'
import productimage19 from '../../images/product-img-19.jpg'
import { MagnifyingGlass } from 'react-loader-spinner'
import ScrollToTop from "../ScrollToTop";
import Whishlist from "../../Component/Whishlist";
import { CartContext, ProductsContext, UserContext, WishlistContext } from "../../App";
import api from "../../api";

const ShopWishList = () => {
  const { wishlist,wishlistDispatch } = useContext(WishlistContext);
  const {products, setProducts} = useContext(ProductsContext);
  const { cart,cartDispatch } = useContext(CartContext);
   const { user } = useContext(UserContext);

   // loading
   const [loaderStatus, setLoaderStatus] = useState(true);
   useEffect(() => {
     setTimeout(() => {
       setLoaderStatus(false);
     }, 1500);
   }, []);

      const removeProductWishlist = async (id, quantity) => {
        wishlistDispatch({type: "REMOVE_PRODUCT_LIST", payload: id})
        api.removeProductFromWishlist(id);
        return;
        // cartDispatch({type: "SET_PRODUCT_QUANTITY", payload: {id, quantity}})
        //  api.patchCart(id, quantity)
    }

       const addToCart = async (product, quantity=1) => {
        if (user) {
          const resp = await api.addProductsToCart([{product:product, quantity}])
          
          if (resp) {
            cartDispatch({type: "ADD_PRODUCTS", payload: [{...product, quantity}]})
          }
        } else {
          cartDispatch({type: "ADD_PRODUCTS", payload: [{...product, quantity}]})
        }
      }

      // console.log("cart products",cart?.products)
      // console.log("wishlist products",wishlist?.products)
 
  return (
    <div>
      <div>
      {loaderStatus ? (
        <div className="loader-container">
          {/* <PulseLoader loading={loaderStatus} size={50} color="#0aad0a" /> */}
          <MagnifyingGlass
          visible={true}
          height="100"
          width="100"
          ariaLabel="magnifying-glass-loading"
          wrapperStyle={{}}
          wrapperclassName="magnifying-glass-wrapper"
          glassColor="#c0efff"
          color="#0aad0a"
          />
        </div>
      ) : (
        <>
         <>
        <ScrollToTop/>
        </>
      <>
        {/* section */}
        <section className="my-14">
          <div className="container">
            {/* row */}
            <div className="row">
              <div className="offset-lg-1 col-lg-10">
                <div className="mb-8">
                  {/* heading */}
                  <h1 className="mb-1">My Wishlist</h1>
                  <p>There are {wishlist?.products.length} products in this wishlist.</p>
                </div>
                <div>
                  {/* table */}
                  <div className="table-responsive">
                    <table className="table text-nowrap">
                      <thead className="table-light">
                        <tr>
                          <th>   
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                defaultValue
                                id="chechboxOne"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="chechboxOne"
                              ></label>
                            </div>
                          </th>
                          <th />
                          <th>Product</th>
                          <th>Amount</th>
                          <th>Status</th>
                          <th>Actions</th>
                          <th>Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        {wishlist?.products?.map((item)=>(
                        <Whishlist
                        key={item?.id}
                        title={item?.title}
                        image={item?.image?.split(";")[0]}
                        price={item?.price?.toFixed(2)}
                        type={item?.type}
                        onRemove={qty=> removeProductWishlist(item?.id,qty)}
                        addToCart={()=> addToCart(item)}
                        addedToCart={ cart?.products?.some(cartItem => cartItem.itemId == item?.itemId)}
                        />
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
      </>
    )}
  </div>
    </div>
  );
};
export default ShopWishList;
